import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'domains/store'
import { ChannelEvent } from 'domains/store/store.types'

export const selectIsTranslated = (channelEvent?: ChannelEvent) =>
  createSelector(
    (store: RootState) => store.translations.translatedEventGroups,
    (translatedEventGroups: Record<string, string[]>) =>
      Object.values(translatedEventGroups).every(
        (value) =>
          channelEvent?.payload?.id && !value.includes(channelEvent.payload.id),
      ),
  )
